import { render } from "./NextOrder.vue?vue&type=template&id=207ccbfc&scoped=true"
import script from "./NextOrder.vue?vue&type=script&lang=js"
export * from "./NextOrder.vue?vue&type=script&lang=js"

import "./NextOrder.vue?vue&type=style&index=0&id=207ccbfc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-207ccbfc"]])

export default __exports__